module.exports = `
@prefix dc: <http://purl.org/dc/elements/1.1/>.
@prefix foaf: <http://xmlns.com/foaf/0.1/>.
@prefix ical: <http://www.w3.org/2002/12/cal/ical#>.
@prefix ui: <http://www.w3.org/ns/ui#>.
@prefix rdfs: <http://www.w3.org/2000/01/rdf-schema#>.
@prefix sched: <http://www.w3.org/ns/pim/schedule#>.

   ical:Vevent ui:annotationForm <#form2>, <#form3>; ui:creationForm <#form1> .

<#bigForm>
    dc:title
       "Schedule event (single form).";
    a    ui:Group;
    ui:part
       <#form1>, <#form2>, <#form3>.

<#form1>
    dc:title
       "Schedule an event (wizard)";
    a    ui:Form;
    ui:part
        <#form1header>,
        <#eventTitle>,
        <#eventLocation>,
        <#eventComment>,
        <#eventAuthor>.
<#eventTitle>
    a    ui:SingleLineTextField;
    ui:maxLength
       "128";
    ui:property
       ical:summary;
    ui:size
       "40".

<#eventLocation>
    a    ui:SingleLineTextField;
    ui:maxLength
       "512";
    ui:property
       ical:location;
    ui:size
       "40".

<#eventComment>
    a    ui:MultiLineTextField;
#    ui:maxLength
#       "1048";
#    ui:size
#       "40".
    ui:property
       ical:comment.

<#eventAuthor>
   a ui:Multiple; ui:min 1; ui:part <#eventAuthorGroup>; ui:property dc:author.

   <#eventAuthorGroup> a ui:Group; ui:part <#authorName>, <#authorEmail> .
   <#authorName> a ui:SingleLineTextField; ui:property foaf:name .
   <#authorEmail> a ui:EmailField; ui:label "email"; ui:property foaf:mbox .


#####################

<#form2> dc:title "Select possible days"; a ui:Form;
        ui:part <#id1118132113134>, <#id1417314641301> .

    <#id1118132113134> a ui:Heading; ui:contents "Time proposals" .

    <#id1417314641301>
    a ui:Multiple; ui:min 2; ui:part <#id1417314674292>; ui:property sched:option.

   <#id1417314674292> a ui:DateField; ui:property ical:dtstart; ui:label "Date".

   ##################################

   <#form3> dc:title "Select invited people"; a ui:Form; ui:part  <#id1118132113135>, <#id1417314641301b> .
<#id1417314641301b>
   a ui:Multiple; ui:min 1; ui:part <#id1417314674292b>; ui:property sched:invitee.
   <#id1417314674292b> a ui:EmailField; ui:label "email"; ui:property foaf:mbox .
   <#form1header> a ui:Heading; ui:contents "Schedule an event" .
   <#id1118132113135> a ui:Heading; ui:contents "Who to invite" .
`
